import { useState, useCallback } from "react";
import { GitBranch, FloppyDisk } from "@phosphor-icons/react";
import { VersionTimeline } from "../../../components/version/VersionTimeline";
import { DiffViewer } from "../../../components/version/DiffViewer";
import { Button } from "../../../components/ui/Button";

const now = new Date();
const MOCK_VERSIONS = [
  {
    id: "v3",
    snapshot_name: null,
    created_at: new Date(now.getTime() - 2 * 86_400_000).toISOString(),
  },
  {
    id: "v2",
    snapshot_name: "Added methodology",
    created_at: new Date(now.getTime() - 1 * 86_400_000).toISOString(),
  },
  {
    id: "v1",
    snapshot_name: "Initial draft",
    created_at: new Date(now.getTime() - 3 * 86_400_000).toISOString(),
  },
];

const MOCK_OLD_CONTENT = `\\documentclass{article}
\\begin{document}

\\section{Introduction}
This paper presents our findings on...

\\section{Results}
Our experiments show that...

\\end{document}`;

const MOCK_NEW_CONTENT = `\\documentclass{article}
\\begin{document}

\\section{Introduction}
This paper presents our findings on...

\\section{Methodology}
We propose a two-stage approach that combines
supervised pre-training with reinforcement learning.

\\section{Results}
Our experiments show that...

\\end{document}`;

export function DemoVersionsPanel({ onSignIn }: { onSignIn: () => void }) {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const handleSelect = useCallback((id: string) => {
    setSelectedId((prev) => (prev === id ? null : id));
  }, []);

  return (
    <div className="flex flex-col gap-3 px-3 pb-4 pt-2">
      <div className="flex items-center justify-between gap-2">
        <h3 className="flex min-w-0 items-center gap-2 text-sm font-semibold text-[var(--text-primary)]">
          <GitBranch size={18} weight="duotone" className="shrink-0 text-[var(--color-lever-orange)]" />
          <span className="truncate">Version history</span>
        </h3>
        <Button
          variant="secondary"
          size="sm"
          leftIcon={<FloppyDisk size={14} weight="fill" />}
          onClick={onSignIn}
        >
          Create Snapshot
        </Button>
      </div>

      <VersionTimeline
        versions={MOCK_VERSIONS}
        selectedVersionId={selectedId}
        onSelect={handleSelect}
      />

      {selectedId ? (
        <div>
          <p className="mb-2 text-[11px] leading-snug text-[var(--text-muted)]">
            <span className="font-medium text-[var(--text-secondary)]">Diff vs current</span>
            {" · "}
            <span className="text-[var(--text-muted)]">
              {MOCK_VERSIONS.find((v) => v.id === selectedId)?.snapshot_name ?? "Snapshot"}
            </span>
          </p>
          <DiffViewer
            embedded
            oldContent={MOCK_OLD_CONTENT}
            newContent={MOCK_NEW_CONTENT}
          />
        </div>
      ) : (
        <p className="text-[11px] text-[var(--text-muted)]">
          Select a snapshot on the timeline to compare it to the current editor
        </p>
      )}
    </div>
  );
}
